export enum DeviceType {
  Standalone = "Standalone",
  Bundle = "Bundle",
  Device = "Device",
  Both = "Both",
}
